import { render, staticRenderFns } from "./SkillSearchClassSelector.vue?vue&type=template&id=3d9def2b&scoped=true&"
import script from "./SkillSearchClassSelector.vue?vue&type=script&lang=ts&"
export * from "./SkillSearchClassSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSearchClassSelector.vue?vue&type=style&index=0&id=3d9def2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9def2b",
  null
  
)

export default component.exports